import { BottomNavigation, BottomNavigationAction, Button, Paper, Stack, Typography } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import React from 'react';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ArchiveIcon from '@mui/icons-material/Archive';
import { useTheme } from "@mui/material/styles";

import CompressOutlinedIcon from '@mui/icons-material/CompressOutlined';
import CallSplitOutlinedIcon from '@mui/icons-material/CallSplitOutlined';
import MergeOutlinedIcon from '@mui/icons-material/MergeOutlined';
import CallMergeOutlinedIcon from '@mui/icons-material/CallMergeOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const themedStyles = (theme) => {


  return {
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
    }
  }
}

const Footer = (props) => {
  const { greaterThan768, greaterthan375, responsiveData } = props.breakPointsData;
  const [value, setValue] = React.useState(0);
  const theme = useTheme();
  return (

    <Paper sx={{ ...themedStyles(theme).appBar, position: 'fixed', bottom: 0, left: 0, right: 0, height: '6%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#606366' }} elevation={3}>
      <Typography sx={{ fontSize: responsiveData.fontSize }}>© 2024 Copyrighte : heycarter.co.za</Typography>
    </Paper>

  )
}



export default Footer